import { reactive } from "vue";
import { useBadgeHolders } from "./useBadgeHolders";

let instance = null;

export function useBadgeHoldersViewState() {
  if (instance) return instance;

  const badgeHolders = useBadgeHolders();

  const state = reactive({
    filters: {
      values: ["Current"],
      searchText: "",
      searchGhostText: "Search Employee",
      showFilterDialog: false,
      key: "responsibilityBadgeHolders",
      clearSelection: "",
      statusOptions: [],
      filterGroups: [],
      groupsItems: [
        {
          groups: [
            {
              label: "Status",
              type: "check",
              items: [
                { label: "Current", value: "Current" },
                { label: "Expired", value: "Expired" },
                { label: "Terminated", value: "Terminated" },
                { label: "Removed", value: "Removed" },
              ],
            },
          ],
        },
      ],
    },
  });

  const handleRequest = ({ page, itemsPerPage }) => {
    badgeHolders.setPaginationDataLimit(itemsPerPage);
    badgeHolders.setPaginationDataOffset((page - 1) * itemsPerPage);
  };

  const handleSort = (sortData) => {
    const finalSortField = sortData.descending
      ? `-${sortData.field}`
      : `${sortData.field}`;
    badgeHolders.setOrderingDataField(finalSortField);
  };

  const debounce = (func, delay) => {
    let timeout;
    return function (...args) {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), delay);
    };
  };

  const performSearch = (string) => {
    state.filters.searchText = string;
    badgeHolders.setPaginationDataOffset(0);
  };

  const debouncedSearch = debounce(performSearch, 500);

  const handleSearch = (string) => {
    const queryString = string;
    debouncedSearch(queryString);
  };

  const clearSearch = () => {
    state.filters.searchText = "";
  };

  const openBadgeHolderChatter = (item) => {
    // TODO: Implement chatter modal functionality
    console.log("Opening chatter for badge holder:", item);
  };

  const applyFilters = (filters) => {
    const newFilters = filters
      .map((item) => {
        if (item.value !== null) {
          return typeof item === "string" ? item : item.value;
        }
        return null;
      })
      .filter(Boolean);
    state.filters.values = newFilters;
    state.filters.showFilterDialog = false;
    badgeHolders.setPaginationDataOffset(0);
    
    // Separate status and level filters
    const statusFilters = newFilters.filter(filter => 
      ['Current', 'Expired', 'Terminated', 'Removed'].includes(filter)
    );
    const levelFilters = newFilters.filter(filter => 
      ['Apprentice', 'Professional', 'Coach', 'Master'].includes(filter)
    );
    
    // Apply filters
    badgeHolders.setStatusFilter(statusFilters);
    badgeHolders.setLevelFilter(levelFilters);
  };

  const removeFilters = (removedFilter) => {
    badgeHolders.setPaginationDataOffset(0);
    state.filters.clearSelection = removedFilter;
    applyFilters(
      state.filters.values.map((value) => ({ label: value, value: value }))
    );
  };

  const clearFilters = () => {
    state.filters.values = [];
    badgeHolders.setStatusFilter([]);
    badgeHolders.setLevelFilter([]);
    badgeHolders.setPaginationDataOffset(0);
  };

  instance = {
    state,
    handleRequest,
    handleSort,
    handleSearch,
    clearSearch,
    openBadgeHolderChatter,
    applyFilters,
    removeFilters,
    clearFilters,
  };

  return instance;
}

export function resetBadgeHoldersViewState() {
  instance = null;
}

